export enum ItemGroupHeaderLayoutType {
  Legacy = 'legacy',
  Modern = 'modern',
}
